import { defaultRestockPercent } from './constants';

const state = {
  ncr: {
    number: null,
    ncrtype: null,
    original_so_number: null,
    original_so_date: null,
    original_customer_number: null,
    original_warehouse: null,
    cause: null,
    description: null,
    reason: null,
    liability: null,
    subsidiary: null,
    nav_nc_number: null,
    sales_rep: null,
    responsibleparty: null,
    customer_name: null,
    created_date: new Date(),
    created_by: null,
    amended_date: new Date(),
    amended_by: null,
    affectedItems: [],
    status: { id: 1 },
    approved: false,
    approved_date: null,
    approved_by: null,
    foc_from_hq: null,
    foc_customer: null,
    carr_date: null,
    carr_description: null,
    related_capa: null,
    netsuite_rtn_status: null,
    netsuite_ord_status: null,
    order: {
      date_required: null,
      shipping_instructions: null,
      orderItems: [],
      total: 0,
      overhead_cost: 0,
      transport_cost: 0,
      installation_cost: 0,
      total_cost: 0,
      address: {
        address_line_1: null,
        address_line_2: null,
        address_city: null,
        address_country: null,
        address_code: null,
        address_postcode: null,
      },
      warehouse: null,
      contact: {
        contact_name: null,
        contact_number: null,
      },
    },
    return: {
      number: null,
      return_instructions: null,
      total_cost: 0,
      item_cost: 0,
      logistic_cost: 0,
      invoice_cost: 0,
      restock_cost: 0,
      discount: 0,
      restock_percent: defaultRestockPercent,
      booking_slot: null,
      opening_times: null,
      collection: null,
      condition: null,
      invoice_posting: null,
      restock_charge: null,
      return_reason: null,
      warehouse: null,
      returnItems: [],
      returnPallets: [],
      customer_name: null,
      address: {
        address_line_1: null,
        address_line_2: null,
        address_city: null,
        address_country: null,
        address_code: null,
        address_postcode: null,
      },
      contact: {
        contact_name: null,
        contact_number: null,
        contact_email: null,
      },
    },
    files: [],
  },
  uploads: [],
  salesOrders: [],
  products: [],
  subsidiaries: [],
  users: [],
  liabilities: [],
  reasons: [],
  restock_charge: [],
  incoterms: [],
  currencies: {
    EUR: '€',
    GBP: '£',
    USD: '$',
    JPY: '¥',
    MXN: '$',
    RUB: ' ₽',
    AED: 'د.إ',
    AUD: '$',
    DKK: ' kr',
    SEK: ' kr',
    PLN: 'zł',
  },
};

export default state;
